// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Left Panel right border when it is visible by breakpoint */
.panel-left.panel-in-breakpoint:before {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0,0,0,0.1);
  content: '';
  z-index: 6000;
}

/* Hide navbar link which opens left panel when it is visible by breakpoint */
.panel-left.panel-in-breakpoint ~ .view .navbar .panel-open[data-panel="left"] {
  display: none;
}

/*
  Extra borders for main view and left panel for iOS theme when it behaves as panel (before breakpoint size)
*/
.ios .panel-left:not(.panel-in-breakpoint).panel-in ~ .view-main:before,
.ios .panel-left:not(.panel-in-breakpoint).panel-closing ~ .view-main:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0,0,0,0.1);
  content: '';
  z-index: 6000;
}`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf;;AAEA,6EAA6E;AAC7E;EACE,aAAa;AACf;;AAEA;;CAEC;AACD;;EAEE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,aAAa;AACf","sourcesContent":["/* Left Panel right border when it is visible by breakpoint */\n.panel-left.panel-in-breakpoint:before {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  background: rgba(0,0,0,0.1);\n  content: '';\n  z-index: 6000;\n}\n\n/* Hide navbar link which opens left panel when it is visible by breakpoint */\n.panel-left.panel-in-breakpoint ~ .view .navbar .panel-open[data-panel=\"left\"] {\n  display: none;\n}\n\n/*\n  Extra borders for main view and left panel for iOS theme when it behaves as panel (before breakpoint size)\n*/\n.ios .panel-left:not(.panel-in-breakpoint).panel-in ~ .view-main:before,\n.ios .panel-left:not(.panel-in-breakpoint).panel-closing ~ .view-main:before {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 1px;\n  background: rgba(0,0,0,0.1);\n  content: '';\n  z-index: 6000;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
